import { apiClient } from 'v4/core/apiClient';
import { createResourceTypeApi } from './resource-types.api.http';

export const myResourceTypeApi = createResourceTypeApi(apiClient);
